// @flow

export const SORTABLE_DIRECTION = {
    HORIZONTAL: 'HORIZONTAL',
    VERTICAL: 'VERTICAL'
};

export const SORTABLE_FILTER = 'sortable__filter';

export const EVENT_TYPES = {
    UPDATE: 'update',
    ADD: 'add',
    REMOVE: 'remove'
};

export const SORTABLE_CLASSNAME = 'sortable__list';
